import { render, staticRenderFns } from "./cardTemplateVip16.vue?vue&type=template&id=8710caa0&scoped=true&"
import script from "./cardTemplateVip16.vue?vue&type=script&lang=js&"
export * from "./cardTemplateVip16.vue?vue&type=script&lang=js&"
import style0 from "./cardTemplateVip16.vue?vue&type=style&index=0&id=8710caa0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8710caa0",
  null
  
)

export default component.exports